import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getLicDropDownValue',
  pure: false
})
export class GetLicDropDownValuePipe implements PipeTransform {

  transform(array:any,  type: string, currentMode: string = "",  licSlug: string = "", beatData?: any, currentValue?: any): any {
    let finalArray: Array<any> = [];
    switch(type) {
      case 'publishingRights' :
        array.map((item: any) => {
          if (item <= 50) {
          finalArray.push(item.toString());
          }
        });
        break;
      case 'masterRecording':
        if (currentMode === "auto") {
          array.map((item: any) => {
            if (item <= 3) {
              finalArray.push(item.toString());
            }
          })
        } else {
          array.map((item: any) => {
            if (item <= 5) {
              finalArray.push(item.toString());
            }
          })
        }
        // Always include the current value if it's not already in the array
        if (currentValue !== null && currentValue !== undefined && !finalArray.includes(currentValue.toString())) {
          finalArray.push(currentValue.toString());
          finalArray.sort((a, b) => parseInt(a) - parseInt(b));
        }
      
      break;
      case 'period':
          if (currentMode === "auto") {
            array.map((item: any) => {
              if (item <= 5) {
               finalArray.push(item.toString());
              }
            }) 
          } else {
            const filtered = !beatData ? array.filter((item: any) => item >= 5) : array;
            finalArray = filtered.map((item: any) => item.toString());
          }
          if (currentValue !== null && currentValue !== undefined && !finalArray.includes(currentValue.toString())) {
            finalArray.push(currentValue.toString());
            finalArray.sort((a, b) => parseInt(a) - parseInt(b));
          }
          break;
      default:
        if (licSlug === 'exclusive') {
          array.map((item: any) => {
            if (item <= 50) {
             finalArray.push(item.toString());
            }
          })
        } else {
          array.map((item: any) => {
            if (item <= 50) {
             finalArray.push(item.toString());
            }
          })
        }
        break;
    }
    return finalArray;
  }

}
